import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import { cleanValue } from "../../../utils/commonComponent/fetched";
import { booleanOptions } from "../../constants/inspectionOption";
const HeaderImg = "/img/header.png";

let config = {
  margin: 18,
  borderMagin: 10,
  headerHeight: 80,
  footerHeight: 10,
  fontSize: 9,
  bordergap: 2,
  currentY: 0,
};

const getLabel = (id) => {
  const found = booleanOptions.find((option) => option.id == id);
  return found ? found.label : "";
};

// draw border from all sides
const drawMarginRect = (doc) => {
  const totalWidth = doc.internal.pageSize.getWidth();
  const totalHeight = doc.internal.pageSize.getHeight();
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(
    config?.borderMagin,
    config?.borderMagin + config?.headerHeight + config.bordergap,
    totalWidth - config?.borderMagin * 2,
    totalHeight -
      config?.borderMagin * 2 -
      (config?.headerHeight + config?.footerHeight) -
      config.bordergap
  );
};

// Helper function to draw the header and footer images
function addHeaderFooter(doc) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let letterHead = HeaderImg;

  // Draw header image at the top (x:0, y:0)
  doc.addImage(letterHead, "PNG", 0, 0, pageWidth, config?.headerHeight);
  // doc.addImage(
  //   UnitechFooter,
  //   "PNG",
  //   0,
  //   pageHeight - config?.footerHeight,
  //   pageWidth,
  //   config?.footerHeight
  // );
}

function generateHeaderSection(doc, inputStates, inspectionRows) {
  const invoiceTitle = "INSPECTION SERVICE REQUEST";
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 102);
  doc.text(
    invoiceTitle,
    doc.internal.pageSize.getWidth() / 2,
    config?.headerHeight + config?.margin + 5 + config.bordergap,
    {
      align: "center",
    }
  );
  const startYPos =
    config?.headerHeight + 12 + config.bordergap + config?.margin;

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [18, 15, 20, 17, 15, 15];
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  const bodyData = [
    [
      {
        content: "Service Request Date",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: inputStates?.requisitionDate
          ? moment(inputStates?.requisitionDate).format("DD/MM/YYYY")
          : "",
      },
      {
        content: "Services Request No.",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: cleanValue(inputStates?.serviceRequestNo),
      },
      { content: "Rev:", styles: { fontStyle: "bold", halign: "left" } },
      {
        content: cleanValue(inputStates?.revisionNumber),
      },
    ],
    [
      {
        content: "Date of Inspection & duration:",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: inputStates?.inspectionDate
          ? moment(inputStates?.inspectionDate).format("DD/MM/YYYY")
          : "" + cleanValue(inputStates?.duration),
        colSpan: 4,
      },
    ],
    [
      {
        content: "Name of the Client:",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.companyName),
        colSpan: 4,
      },
    ],
    [
      {
        content: "Present Address (for billing):",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.address),
        colSpan: 4,
      },
    ],
    [
      {
        content: "Contact person name & details:",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.contact),
        colSpan: 4,
      },
    ],
    [
      {
        content: "GSTIN (if applicable):",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.gstNumber),
        colSpan: 4,
      },
    ],
    [
      {
        content: "Type of Services",
        styles: { fontStyle: "bold", halign: "center" },
        colSpan: 6,
      },
    ],
    [
      {
        content: "Final Random Inspection",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.finalRandomInspection),
      },
      {
        content: "First Inspection",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.firstInspection),
      },
      {
        content: "Re Inspection",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.reinspection),
      },
    ],
    [
      {
        content: "During Production Inspection",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.productionInspection),
      },
      {
        content: "If Re-inspection, previous report number",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: cleanValue(inputStates?.previousReportNo),
        colSpan: 3,
      },
    ],
    [
      {
        content: "Sample Random Testing",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.randomTesting),
      },
      {
        content: "First Inspection",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.firstInspection),
      },
      {
        content: "Supervision of Shipment",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.supervisionShippment),
      },
      {
        content: "Welding related services",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.weldingService),
      },
    ],
    [
      {
        content: "Vendor capability & capability assessment",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.vendorCapability),
      },
      {
        content: "Others",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: getLabel(inputStates?.others),
        colSpan: 3,
      },
    ],
    [
      {
        content: "Code of const./spec/TDC(whichever appl.)",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.codeConstnSpec),
        colSpan: 4,
      },
    ],
    [
      {
        content: "Location of Inspection",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.inspectionLocation),
        colSpan: 4,
      },
    ],
  ];

  // ➕ Add Inspection Services Section
  const insptservices = (() => {
    try {
      return JSON.parse(inputStates?.inspectionservices || "[]");
    } catch {
      return [];
    }
  })();
  const services = Array.isArray(insptservices) ? insptservices : [];
console.log({services})
  if (services.length) {
    bodyData.push(
      [
        {
          content: "Name of product to be inspected & quantity",
          styles: { fontStyle: "bold", halign: "center" },
          colSpan: 6,
        },
      ],
      [
        {
          content: "Sr.No.",
          styles: { fontStyle: "bold",valign:"middle", halign: "center" },
        },
        {
          content: "Inspection Items",
          styles: { fontStyle: "bold",valign:"middle", halign: "center" },
          colSpan: 3,
        },
        {
          content: "Quantity",
          styles: { fontStyle: "bold",valign:"middle", halign: "center" },
          colSpan: 2,
        },        
      ],
      ...services.map((s, i) => [
        { content: i + 1,  styles: { valign:"middle", halign: "center" }},
        { content: cleanValue(s?.subcategory), colSpan: 3, styles: { valign:"middle", halign: "center" }},
        { content: cleanValue(s?.quantity), colSpan: 2, styles: { valign:"middle", halign: "center" }},
      ])
    );
  }

  bodyData.push(
    [
      {
        content: "Terms Conditions",
        styles: { fontStyle: "bold", halign: "center" },
        colSpan: 6,
      },
    ],
    [
      {
        content: cleanValue(inputStates?.termsConditions),
        styles: { halign: "justify" },
        colSpan: 6,
      },
    ]
  );

  autoTable(doc, {
    startY: startYPos,
    body: bodyData,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      valign: "middle",
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
    },
    margin: {
      top: config?.borderMagin + config?.headerHeight + config.bordergap + 5,
      left: config.margin,
      right: config.margin,
      bottom: config.footerHeight + config.bordergap + 10,
    },
    headStyles: { fillColor: [217, 217, 217] },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
      4: { cellWidth: columnWidths[4] },
      5: { cellWidth: columnWidths[5] },
    },
  });

  const newY = doc.lastAutoTable.finalY;
  config.currentY = newY;
}

export function generatePDFService(inputStates, inspectionRows, letterHead) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "a4",
    compress: true,
  });

  generateHeaderSection(doc, inputStates, inspectionRows);

  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    if (letterHead){
     addHeaderFooter(doc);
    }
    drawMarginRect(doc);
  }

  const totalPages = doc.getNumberOfPages();
  for (let page = 1; page <= totalPages; page++) {
    doc.setPage(page);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(config.fontSize - 2);
    doc.setTextColor(0);
     let pageWidth = doc.internal.pageSize.getWidth();
    let pageHeight = doc.internal.pageSize.getHeight();
    let y = pageHeight - config.footerHeight; // Bottom position
    // Left-side text
    let leftText = "Format No. BFI-FM-SALES-7 Rev-1,  Date: 05.08.2023";
    doc.text(
      leftText,
      config.margin - 5, // Align left side with margin
      y
    );
    // Right-side text (page number)
    let rightText = `Page No : ${String(page).padStart(2, "0")} of ${String(
      totalPages
    ).padStart(2, "0")}`;

    doc.text(
      rightText,
      pageWidth - config.margin - 55,
      y,
      { align: "left" }
    );
  }

  doc.save(`service_request.pdf`);
}
